import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './utils/auth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewService from './pages/NewService';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Reports from './pages/Reports';
import HospitalManagement from './pages/HospitalManagement';
import HospitalEarnings from './pages/HospitalEarnings';
import AnesthesiaManagement from './pages/AnesthesiaManagement';
import UserProfile from './pages/UserProfile';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public routes */}
          <Route 
            path="/login" 
            element={isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Login />} 
          />
          
          {/* Protected routes */}
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/services/new" 
            element={
              <ProtectedRoute>
                <NewService />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/services/:id" 
            element={
              <ProtectedRoute>
                <ServiceDetail />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/services" 
            element={
              <ProtectedRoute>
                <Services />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reports" 
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/hospitals" 
            element={
              <ProtectedRoute>
                <HospitalManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/hospital-earnings" 
            element={
              <ProtectedRoute>
                <HospitalEarnings />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/anesthesia-types" 
            element={
              <ProtectedRoute>
                <AnesthesiaManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            } 
          />
          
          {/* Default redirect */}
          <Route 
            path="/" 
            element={<Navigate to={isAuthenticated() ? "/dashboard" : "/login"} replace />} 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;